import axios from "axios";
import API_CONFIG from "./ApiDeclaration";

export function DownloadTemplate(param) {
    const URL = API_CONFIG.GET_TEMPLATE_OF_TABLE + param;
    return axios.get(URL);
}